export const PAYMENT_STATUS = {
  IN_PROGRESS: 'in-progress',
  PAID: 'paid',
} as const;

export type PaymentStatus = ValueOf<typeof PAYMENT_STATUS>;
